export const EXCMAGREEMENTSLA_SHOW_RESET = 'EXCMAGREEMENTSLA_SHOW_RESET'
export const EXCMAGREEMENTSLA_SHOW_SET_ERROR = 'EXCMAGREEMENTSLA_SHOW_SET_ERROR'
export const EXCMAGREEMENTSLA_SHOW_SET_RETRIEVED = 'EXCMAGREEMENTSLA_SHOW_SET_RETRIEVED'
export const EXCMAGREEMENTSLA_SHOW_TOGGLE_LOADING = 'EXCMAGREEMENTSLA_SHOW_TOGGLE_LOADING'
